import { jsx as o } from "react/jsx-runtime";
import { CELEBRUS_CLASSES as t } from "../utils/analytics/index.js";
import { Image as l } from "@sitecore-jss/sitecore-jss-nextjs";
import { M as n } from "./module-link.BIP-6VCP.js";
const d = ({ field: e, linkClassName: r, logoClassName: a, logoLinkUrl: i = "" }) => {
  const { header: m } = t, s = i || "/";
  return /* @__PURE__ */ o(n, { className: `${m.utilNav} ${r} link-plain`, href: s, children: /* @__PURE__ */ o(l, { className: a, field: e, editable: !1, loading: "eager" }) });
};
export {
  d as L
};
